import React, { useCallback, useMemo } from 'react';
import ModalComponent from 'components/modal/modalComponent';
import { useValidateManualForm } from './useValidateManualForm';
import { FormProvider } from 'react-hook-form';
import { ModalButtonProps } from 'components/modal/modal.interfaces';
import { twMerge } from 'tailwind-merge';
import ButtonComponent from 'components/button/buttonComponent';
import { FormInput } from 'components/stepper/field-components';

interface MobileManualFormProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileManualForm: React.FC<MobileManualFormProps> = ({
  isOpen,
  setIsOpen,
}) => {
  const { methods, handleSubmit, loading } = useValidateManualForm();
  const handleClose = useCallback(() => setIsOpen(false), [setIsOpen]);

  const Buttons: ModalButtonProps[] = useMemo(
    () => [
      {
        label: 'Submit',
        testID: 'submit',
        htmlButtonType: 'submit',
        showSpinner: loading,
        disabled: loading,
        className: '!whitespace-nowrap !text-sm',
      },
      {
        label: 'cancel',
        onClick: handleClose,
        testID: 'close',
        htmlButtonType: 'button',
        type: 'underline',
        className: '!text-sm',
      },
    ],
    [handleClose, loading],
  );

  return (
    <ModalComponent
      title="Register new test kit"
      onClose={handleClose}
      isOpen={isOpen}
    >
      <FormProvider {...methods}>
        <form
          className="h-full flex flex-col"
          onSubmit={methods.handleSubmit(handleSubmit)}
          noValidate
        >
          <FormInput
            isRequired
            name={'swabBarcode'}
            placeholder={'Enter test kit ID number'}
            label={'Test kit ID number'}
          />
          <FormInput
            name={'trackingNumber'}
            placeholder={'Enter test return tracking number'}
            label={'Test kit Return Tracking number'}
            describe={
              'If you do not provide your return tracking number, then Codex Labs cannot be held responsible in the event of carrier loss'
            }
          />
          <div
            className={twMerge(
              'flex mt-auto flex-col -mx-7 px-7 -mb-10 w-[calc(100%_+_3rem)] py-30 rounded-b-10 gap-5 justify-between bg-white desktop:flex-row-reverse desktop:px-10',
            )}
          >
            {Buttons.length > 0 && (
              <div
                className={twMerge(
                  'flex flex-row-reverse gap-5 desktop:gap-30',
                )}
              >
                {Buttons.map((button, index) => (
                  <ButtonComponent key={index} {...button}>
                    {button.label}
                  </ButtonComponent>
                ))}
              </div>
            )}
          </div>
        </form>
      </FormProvider>
    </ModalComponent>
  );
};

export default MobileManualForm;
